/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnteprimaDto
 */
export interface AnteprimaDto {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AnteprimaDto
     */
    anteprimaItems?: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the AnteprimaDto interface.
 */
export function instanceOfAnteprimaDto(value: object): value is AnteprimaDto {
    return true;
}

export function AnteprimaDtoFromJSON(json: any): AnteprimaDto {
    return AnteprimaDtoFromJSONTyped(json, false);
}

export function AnteprimaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnteprimaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'anteprimaItems': json['anteprimaItems'] == null ? undefined : json['anteprimaItems'],
    };
}

export function AnteprimaDtoToJSON(value?: AnteprimaDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'anteprimaItems': value['anteprimaItems'],
    };
}

